
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/subscriptions/[productPublicId]/purchase",
      function () {
        return require("private-next-pages/[publicId]/subscriptions/[productPublicId]/purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/subscriptions/[productPublicId]/purchase"])
      });
    }
  